import { styled } from '@mui/material/styles';
import { Box, Card, Paper } from '@mui/material';

export const StyledRoot = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
}));

export const StyledCard = styled(Card)(({ theme }) => ({
    //   maxWidth: 900,
    width: '100%',
    padding: theme.spacing(1),
}));

export const StyledContentBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
}));

export const StyledLeftColumn = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 280,
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
        minWidth: '100%',
    },
}));

export const StyledMerchantGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));

// export const StyledMerchantItem = styled(Paper)(({ theme }) => ({
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e0e0e0',
//     backgroundColor: '#f9f9f9',
//     padding: theme.spacing(1.5),
//     textAlign: 'center',
//     wordBreak: 'break-word',
//     borderRadius: theme.shape.borderRadius,
//     marginBottom: theme.spacing(1.5),
// }));

export const StyledMerchantItem = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    textAlign: 'center',
    wordBreak: 'break-word',
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1.5),
    boxShadow: theme.shadows[1],
    transition: 'all 0.3s ease',

    '&:hover': {
        boxShadow: theme.shadows[4],
    },
}));


export const StyledRightColumn = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 280,
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
        minWidth: '100%',
        marginTop: theme.spacing(2),
    },
}));

export const StyledChargesColumn = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 280,
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
        minWidth: '100%',
        marginTop: theme.spacing(2),
    },
}));

export const StyledBankingBox = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
}));
